import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoggingWidgetModule } from '../logging/logging-widget.module'
import { MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { LoggingDetailDialog } from './logging-detail-dialog';


@NgModule({
    declarations: [
      LoggingDetailDialog
    ],
    imports: [
      MatButtonModule,
      MatIconModule,
      MatListModule,
      FormsModule,
      CommonModule,
      LoggingWidgetModule,
      ReactiveFormsModule,
    ],
    exports: [
      LoggingDetailDialog
    ],
    providers: [
    ]
  })
  export class LoggingDetailDialogModule {}
